import { USER_ROLE } from './roles';

export const PERMISSION = {
  MANAGE_USERS: 'manageUsers',
  MANAGE_ADDRESSES: 'manageAddresses',
  ACCESS_API_INTEGRATIONS: 'accessApiIntegrations',
  VIEW_RESERVED_PRODUCTS: 'viewReservedProducts',
  VIEW_ACCOUNT_STATUS: 'viewAccountStatus',
  ACCESS_ACCOUNT_FEATURES: 'accessAccountFeatures',
  ADD_TO_CART: 'addToCart',
  ACCESS_ACCOUNT_SETTINGS: 'accessAccountSettings',
};

export const PERMISSION_ROLES = {
  [PERMISSION.MANAGE_USERS]: [USER_ROLE.SUPER_ADMIN, USER_ROLE.RESELLER_ADMIN],
  [PERMISSION.MANAGE_ADDRESSES]: [USER_ROLE.SUPER_ADMIN, USER_ROLE.RESELLER_ADMIN],
  [PERMISSION.ACCESS_API_INTEGRATIONS]: [USER_ROLE.SUPER_ADMIN, USER_ROLE.RESELLER_ADMIN],
  [PERMISSION.VIEW_RESERVED_PRODUCTS]: [
    USER_ROLE.SUPER_ADMIN,
    USER_ROLE.RESELLER_ADMIN,
    USER_ROLE.RESELLER_USER,
  ],
  [PERMISSION.VIEW_ACCOUNT_STATUS]: [
    USER_ROLE.SUPER_ADMIN,
    USER_ROLE.RESELLER_ADMIN,
    USER_ROLE.RESELLER_USER,
    USER_ROLE.OPERATOR,
    USER_ROLE.INTERNAL_USER,
    USER_ROLE.CATEGORY_MANAGER,
  ],
  [PERMISSION.ACCESS_ACCOUNT_FEATURES]: [
    USER_ROLE.SUPER_ADMIN,
    USER_ROLE.RESELLER_ADMIN,
    USER_ROLE.RESELLER_USER,
    USER_ROLE.OPERATOR,
    USER_ROLE.INTERNAL_USER,
    USER_ROLE.CATEGORY_MANAGER,
  ],
  [PERMISSION.ADD_TO_CART]: [
    USER_ROLE.SUPER_ADMIN,
    USER_ROLE.RESELLER_ADMIN,
    USER_ROLE.RESELLER_USER,
    USER_ROLE.OPERATOR,
    USER_ROLE.INTERNAL_USER,
    USER_ROLE.CATEGORY_MANAGER,
  ],
  [PERMISSION.ACCESS_ACCOUNT_SETTINGS]: [
    USER_ROLE.SUPER_ADMIN,
    USER_ROLE.RESELLER_ADMIN,
    USER_ROLE.RESELLER_USER,
    USER_ROLE.OPERATOR,
    USER_ROLE.INTERNAL_USER,
    USER_ROLE.CATEGORY_MANAGER,
  ],
};
